/* @ngInject */

export default (LENDER) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function LenderDocument(id, type, url, name, version, description, mimeType, format, lender) {
    this.id = id;
    this.type = type;
    this.url = url;
    this.name = name;
    this.version = version;
    this.description = description;
    this.mimeType = mimeType;
    this.format = format;
    this.lender = lender;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  LenderDocument.Blank = function () {
    return LenderDocument.Build({
      id: '',
      type: [],
      url: '',
      name: '',
      version: '',
      description: '',
      mimeType: '',
      format: '',
      lender: {
        id: '',
        abbr: '',
        name: ''
      }
    });
  };

  LenderDocument.Build = function (data) {
    return new LenderDocument(
      data.id,
      data.type,
      data.url,
      data.name,
      data.version,
      data.description,
      data.mimeType,
      data.format,
      data.lender
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  LenderDocument.prototype.getName = function () {
    return this.name;
  };
  LenderDocument.prototype.getExtension = function () {
    return this.format;
  };
  LenderDocument.prototype.getVersion = function () {
    return this.version;
  };
  LenderDocument.prototype.getType = function () {
    return this.type[0];
  };
  LenderDocument.prototype.getTypeName = function () {
    const idType = this.type[0];
    const typeName = _.find(LENDER.DETAILS.DOCUMENT_TYPES, (t) => t?.id === idType);
    return typeName?.value || 'N/A';
  };
  LenderDocument.prototype.getDescription = function () {
    return this.description;
  };

  return LenderDocument;
};
